import React from 'react'
import { StyledPrimaryOdontiaButton } from './styledComponents'

export const OdontiaButton = ({ text, onClick, disabled }) => (
    <StyledPrimaryOdontiaButton variant="contained" {...{ onClick, disabled }}>
        {text}
    </StyledPrimaryOdontiaButton>
)